// NAME-SPACE of modules
import { ModulesMap } from '../modulesMaps'

// MOCK MODULES
import user from './userMockConfig'

export default {
	[ModulesMap.USER]: user,
}
